import styled, { css } from 'styled-components';
import mediaQueries from '@Utils/shared/constants/mediaQueries';
import NicknameGenerator from '@Utils/shared/components/Icons-v3/NicknameGenerator';

export const NicknameGeneratorIcon = styled(NicknameGenerator)`
  align-self: center;
  width: 100%;
  height: auto;
  max-width: 120px;
  @media ${mediaQueries.tablet} {
    max-width: 222px;
  }
  @media ${mediaQueries.desktop} {
    max-width: 159px;
  }
`;

export const GeneratorHead = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${mediaQueries.mobileOrTablet} {
    flex-direction: column;
  }
`;

export const GenerateSection = styled.div<{ isHasTitle: boolean; isCopied: boolean }>`
  margin: 20px 0 0;
  padding: 25px 0 0;
  border-radius: 6px;
  background-color: #3e3f49;

  ${(props) =>
    props.isHasTitle &&
    css`
      padding-bottom: 0;
    `}

  ${(props) =>
    props.isCopied &&
    css`
      padding-bottom: 0;
    `}

  @media ${mediaQueries.mobile} {
    padding: 14px 0 0;
    margin-top: 16px;
  }

  @media ${mediaQueries.tablet} {
    padding: 20px 0 0;
    margin-top: 20px;
  }
`;
